import React, { useEffect, useState } from 'react';
import { Button, TextField, Grid } from '@material-ui/core';
import { CustomGrid, CustomGridItem } from '@/ctComponents/Grid';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import CustomAsyncSelect from '@/components/CustomAsyncSelect';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { addInventory, addLoadContainer, SaveApiResMessage } from '@/actions';
import DateInput from '@/components/DateInput';
import CustomDateInput from '@/components/CustomDateInput';
import { locationOpt } from '@/actions/Helper';
import { debounce } from 'lodash';

import styles from './styles';
import { boolean } from 'yup';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import NumberInput from '@/components/NumberInput';
import LoadingV2 from '@/components/Loading';
import SubmitButton from '@/ctComponents/submitButton';
import CloseButton from '@/ctComponents/closeButton';
import { Input } from '@/components/Input';

export default ({
  notify,
  setData,
  getInventoryList,
  getInventoryLoadList,
  activeTab,
  setOpenAdd,
}) => {
  const cls = styles();
  const [loading, setLoading] = React.useState(false);
  const [btnLoading, setBtnLoading] = React.useState(false);
  const [resetLoading, setResetLoading] = React.useState(false);
  const [showContainerNames, setShowContainerNames] = useState(true);
  const selectOp = useSelector((state) => state.reducer);

  const [form, setFormData] = React.useState({
    size: null,
    ssl: null,
    date: new Date(),
    count: 1,
    loc: null,
    containers: [],
  });
  const [showContainers, setShowContainers] = React.useState(false);

  useEffect(() => {
    let isShowContainers = localStorage.getItem('smart_user_show_containers');
    let isShowContainerNames = localStorage.getItem(
      'smart_user_show_container_names'
    );
    if (isShowContainers === 'true') {
      setShowContainers(true);
    }
    if (isShowContainerNames === 'false') {
      setShowContainerNames(false);
    }
  }, []);

  // Initialize containers when component mounts
  useEffect(() => {
    setFormContainers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setForm = (it, val) => setFormData({ ...form, [it]: val });

  const Add = (setOpenAdd) => {
    setBtnLoading(true);

    // For load containers (all tab), validate container and chassis
    if (activeTab === 'all') {
      let emptyContainers = form.containers.filter(
        (container) =>
          !container.name || container.name.length !== 11 || !container.chases
      );
      if (emptyContainers.length === 0) {
        // Only validate required fields for load containers
        if (!form.size || !form.ssl || form.count < 1) {
          // notify('Can not add, Please check fields.', 'warning');
          SaveApiResMessage({
            title: 'Warning',
            message: 'Can not add, Please check fields.',
            mode: 'warning',
          });
          setBtnLoading(false);
          return;
        }

        addLoadContainer({
          size: form.size,
          ssl: form.ssl,
          count: form.count,
          containers: form.containers,
        })
          .then((res) => {
            setOpenAdd(false);
            // notify(res, 'success');
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res,
              mode: 'success',
            });
            getInventoryLoadList();
            Reset();
            setBtnLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
            setData([]);
            setBtnLoading(false);
          });
      } else {
        // notify('Invalid Container or Chassis Number.', 'warning');
        SaveApiResMessage({
          title: 'Warning',
          message: 'Invalid Container or Chassis Number.',
          mode: 'warning',
        });
        setBtnLoading(false);
      }
    } else {
      // For dropped containers, keep original validation
      let emptyContainers = form.containers.filter(
        (container) =>
          !container.name || container.name.length !== 11 || !container.chases
      );
      if (emptyContainers.length === 0) {
        for (let el in form) {
          if (!form[el]) {
            // notify('Can not add, Please check fields.', 'warning');
            SaveApiResMessage({
              title: 'Warning',
              message: 'Can not add, Please check fields.',
              mode: 'warning',
            });
            setBtnLoading(false);
            return;
          }
        }

        addInventory({
          ...form,
        })
          .then((res) => {
            setOpenAdd(false);
            // notify(res, 'success');
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res,
              mode: 'success',
            });
            getInventoryList();
            Reset();
            setBtnLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
            setData([]);
            setBtnLoading(false);
          });
      } else {
        // notify('Invalid Container or Chassis Number.', 'warning');
        SaveApiResMessage({
          title: 'Warning',
          message: 'Invalid Container or Chassis Number.',
          mode: 'warning',
        });
        setBtnLoading(false);
      }
    }
  };

  const Reset = () => {
    setResetLoading(true);
    setFormData({
      size: null,
      ssl: null,
      date: new Date(),
      count: 1,
      loc: null,
      containers: form.containers,
    });
    // setFormContainers();
    setTimeout(() => {
      setResetLoading(false);
    }, 500);
  };

  const setFormContainers = () => {
    let containers = [];
    for (let i = 0; i < form.count; i++) {
      if (form.containers[i]) {
        containers.push(form.containers[i]);
      } else {
        containers.push({ name: '', chases: '' });
      }
    }
    setForm('containers', containers);
  };

  useEffect(() => {
    setFormContainers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.count]);

  if (loading) return <LoadingV2 />;

  return (
    <div className="w-full overflow-y-auto">
      <div style={{ maxWidth: '650px', padding: '12px 0px' }}>
        Fill out the form below and click Add to list. You can edit or delete
        entries later from your inventory list.
      </div>
      <div className="space-y-4 md:space-y-0 md:grid grid-cols-1 md:grid-cols-2 gap-4 max-w-screen-sm">
        <CustomSelectEx
          height={48}
          maxHeight={48}
          title={'Size'}
          placeholder={
            form.size?.label !== null
              ? form.size?.label
              : form.size
              ? form.size.label
              : 'Size'
          }
          value={form.size}
          onChange={(item) => setForm('size', item)}
          options={selectOp.size}
          dropdown
        />
        <CustomSelectEx
          height={48}
          maxHeight={48}
          title={'SSL'}
          placeholder={
            form.ssl?.label !== null
              ? form.ssl?.label
              : form.ssl
              ? form.ssl.label
              : 'SSL'
          }
          value={form.ssl}
          onChange={(item) => setForm('ssl', item)}
          options={selectOp.ssl}
          dropdown
        />
        {activeTab !== 'all' && (
          <CustomAsyncSelect
            height={48}
            maxHeight={48}
            title="Location"
            placeholder="Search your location "
            value={form.loc}
            loadOptions={locationOpt}
            onChange={(item) => setForm('loc', item)}
            cacheOptions={true}
            defaultOptions={true}
            dropdown
            isClearable
          />
        )}

        {activeTab !== 'all' && (
          <CustomDateInput
            height={48}
            title="Date"
            placeholder="Date"
            value={form.date}
            onChange={(item) => setForm('date', item)}
            format="MM/dd/yyyy"
            // className={cls.date}
          />
        )}
        <NumberInput
          label="Number"
          value={form.count}
          onChange={(value) => setForm('count', value)}
          min={1}
          onIncrement={() => {
            setForm('count', form.count + 1);
          }}
          onDecrement={() => setForm('count', Math.max(1, form.count - 1))}
        />
      </div>
      <div
        className={`py-4 px-4 space-y-4 md:space-y-0 md:grid grid-cols-1 md:grid-cols-2 gap-4 max-w-screen-sm ${cls.containerSection}`}>
        {
          // showContainers &&
          form.containers.map((item, i) => (
            <div className="flex flex-col gap-2">
              <Input
                type="text"
                backgroundColor={'#F5F7FA'}
                placeholder={`Container ${i + 1}`}
                // className={cls.textInput}
                InputProps={{ disableUnderline: true }}
                min={11}
                max={11}
                maxLength={11}
                value={form.containers[i].name}
                error={
                  form.containers[i].name &&
                  form.containers[i].name.length !== 11 &&
                  (form.containers[i].showError || form.containers[i].isBlurred)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  e.persist();

                  // Clear any existing timeout
                  if (form.containers[i].validationTimeout) {
                    clearTimeout(form.containers[i].validationTimeout);
                  }

                  // Set new timeout
                  const timeout = setTimeout(() => {
                    if (value && value.length !== 11) {
                      setForm('containers', [
                        ...form.containers.slice(0, i),
                        {
                          ...form.containers[i],
                          name: value,
                          showError: true,
                          isBlurred: false,
                        },
                        ...form.containers.slice(i + 1),
                      ]);
                    }
                  }, 3000);

                  setForm('containers', [
                    ...form.containers.slice(0, i),
                    {
                      ...form.containers[i],
                      name: value,
                      showError: false,
                      isBlurred: false,
                      validationTimeout: timeout,
                    },
                    ...form.containers.slice(i + 1),
                  ]);
                }}
                onBlur={() => {
                  const value = form.containers[i].name;
                  if (value && value.length !== 11) {
                    setForm('containers', [
                      ...form.containers.slice(0, i),
                      {
                        ...form.containers[i],
                        isBlurred: true,
                        showError: false,
                      },
                      ...form.containers.slice(i + 1),
                    ]);
                  }
                }}
              />
              {form.containers[i].name &&
                form.containers[i].name.length !== 11 &&
                (form.containers[i].showError ||
                  form.containers[i].isBlurred) && (
                  <div
                    style={{
                      color: 'red',
                      fontSize: '12px',
                      marginTop: '4px',
                    }}>
                    Invalid container number (11 characters).
                  </div>
                )}
              <Input
                backgroundColor={'#F5F7FA'}
                type="text"
                placeholder={`Chassis ${i + 1}`}
                // className={cls.textInput}
                InputProps={{ disableUnderline: true }}
                inputProps={{ min: 1 }}
                value={form.containers[i].chases}
                onChange={(e) => {
                  setForm('containers', [
                    ...form.containers.slice(0, i),
                    {
                      ...form.containers[i],
                      chases: e.target.value,
                    },
                    ...form.containers.slice(i + 1),
                  ]);
                }}
              />
            </div>
          ))
        }
      </div>
      <div className={cls.buttonsSection}>
        <CloseButton
          borderColor={'#FB3748'}
          color={'#FB3748'}
          text={'Reset'}
          onClick={() => Reset()}
          loading={resetLoading}
        />
        <div className="flex flex-row gap-3">
          <CloseButton onClick={() => setOpenAdd(false)} text={'Cancel'} />
          <SubmitButton
            text={'Add to list'}
            onClick={() => Add(setOpenAdd)}
            loading={btnLoading}
            disable={form.containers.some(
              (container) =>
                container.name &&
                container.name.length !== 11 &&
                (container.showError || container.isBlurred)
            )}
          />
        </div>
      </div>

      {/* </div> */}
    </div>
  );
};
